import styled from 'styled-components'
import { Logo } from '../Logo'

const AuthLogo = styled(Logo)`
  width: 12.5rem;
`

export default AuthLogo
